import { useAppState } from '/@/App/state'
import { useConfig } from '/@/core/config'
import { useUser } from '/@/data/user'

class AuthService {
  app = useAppState()
  config = useConfig()

  async checkSession(user: ReturnType<typeof useUser>) {
    if (user.isLoggedIn || this.config.env === 'cypress') return

    await user.fetchCurrentUser()
  }

  async logOut() {
    if (this.config.mode !== 'development' && this.config.mode !== 'e2e') {
      window.location.href = this.config.urls.admin + '/logout'
    }
  }

  async logIn(user: ReturnType<typeof useUser>) {
    if (this.config.mode === 'development' || this.config.mode === 'e2e') {
      await this.checkSession(user)
    } else {
      const returnUrl =
        window.location.protocol !== 'https:'
          ? window.location.href.replace('http', 'https')
          : window.location.href
      window.location.href =
        this.config.urls.admin +
        '/login?returnUrl=' +
        encodeURIComponent(returnUrl)
    }
  }
}

function create() {
  return new AuthService()
}

let cachedApi: ReturnType<typeof create>

export function useAuth() {
  if (!cachedApi) {
    cachedApi = create()
  }
  return cachedApi
}
